import { SettingsFieldRow, SettingsSection } from 'components/Settings';
import { useLanguageSwitcher } from 'hooks/useLanguageSwitcher';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select, Text, Tooltip } from 'shell/components';
import { LanguageList } from 'utils/constants';

const InterfaceLanguage = ({ sectionId }) => {
    const { currentLanguage, switchLanguage } = useLanguageSwitcher();
    const { t } = useTranslation();
    const [language, setLanguage] = useState(currentLanguage);

    const handleChange = (value) => {
        setLanguage(value);
        if (value !== currentLanguage) switchLanguage(value);
    };

    return (
        <SettingsSection
            id={sectionId}
            sectionGap={4}
            title={t('account-settings.general-settings.title', 'Interface Language')}
            titleAdornment={
                <Tooltip
                    content={t(
                        'account-settings.general-settings.personal-language-preference-description',
                        'This change affects only your view in this course and does not impact students. Outside the course, your default language will be used.'
                    )}
                    type='info'
                />
            }
        >
            <SettingsFieldRow
                label={
                    <Text variant='p2'>
                        {t(
                            'account-settings.general-settings.personal-language-preference',
                            'Personal Language Preference'
                        )}
                    </Text>
                }
            >
                <Select
                    labelId='settings-language-select-label'
                    value={language}
                    onChange={(event) => handleChange(event.target.value)}
                    sx={{ width: '100%' }}
                >
                    {LanguageList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </SettingsFieldRow>
        </SettingsSection>
    );
};

export default InterfaceLanguage;
